import Vue from "vue";

const STORAGE_KEY = "theme";
const THEME_COLORS = { light: "#22333B", dark: "#0f1518" };

function readSaved() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved === "dark" || saved === "light" ? saved : null;
    } catch (e) {
        return null;
    }
}

// Light is the default; dark is used only after the visitor picks it.
export const themeState = Vue.observable({
    theme: readSaved() || "light"
});

function apply(theme) {
    document.documentElement.setAttribute("data-theme", theme);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", THEME_COLORS[theme]);
}

export function setTheme(theme) {
    themeState.theme = theme;
    apply(theme);
    try {
        localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) { /* storage unavailable */ }
}

export function toggleTheme() {
    setTheme(themeState.theme === "dark" ? "light" : "dark");
}

apply(themeState.theme);
